import { nanoid } from "nanoid";

import { handleError } from "@/redux/utils/error";
import { parseApiError } from "@/utils/parseApiError";

import * as plannerAlertActions from "./alerts/alerts.actions";
import { ALERT_VARIANT } from "./alerts/constants";

// Failures while saving an event show the planner's own red toast (frame 1192:11114), the same one
// the remove flow uses, instead of the app-wide alert in the bottom-left corner.
export const handleEventError = (error, dispatch) => {
  if (!error?.response) {
    throw error;
  }

  // A dead session still has to log the user out, and only the app-wide handler does that.
  if (error.response.status === 401) {
    handleError(error, dispatch);
    return;
  }

  const { message } = parseApiError(error);
  dispatch(
    plannerAlertActions.addAlert({
      id: nanoid(),
      message,
      variant: ALERT_VARIANT.DANGER,
    })
  );

  // handleError throws after alerting and the callers are built around that, so keep it.
  throw new Error(JSON.stringify(error.response.data));
};

export default {};
